export const API_BASE_URL = "https://www.asu.unsa.ba/v2/index.php?rest_route=/wp/v2";

